import authService from './authService';

class SpotifyService {
  constructor() {
    this.baseUrl = 'https://api.spotify.com/v1';
    this.lastQuery = ''; // Ajout du stockage de la dernière requête
  }

  async getHeaders() {
    try {
      const token = await authService.getAccessToken();
      if (!token) {
        throw new Error('No access token available');
      }
      return {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      };
    } catch (error) {
      console.error('Error getting headers:', error);
      throw error;
    }
  }

  async searchPlaylists(query, limit = 50, offset = 0) {
    try {
      // Gestion de la requête
      if (query) {
        this.lastQuery = query;
      } else {
        query = this.lastQuery;
      }

      if (!query) {
        throw new Error('Aucun terme de recherche fourni');
      }

      const headers = await this.getHeaders();
      const response = await fetch(
        `${this.baseUrl}/search?q=${encodeURIComponent(query)}&type=playlist&limit=${limit}&offset=${offset}`,
        { 
          method: 'GET',
          headers 
        }
      );

      if (!response.ok) {
        const errorText = await response.text();
        console.error('Search failed:', errorText);
        throw new Error(`Failed to search playlists: ${response.status}`);
      }

      const data = await response.json();

      // Récupérer les détails pour chaque playlist
      if (data.playlists && data.playlists.items) {
        const playlistsWithDetails = await Promise.all(
          data.playlists.items.map(async (playlist) => {
            if (!playlist) return null;
            try {
              const details = await this.getPlaylistDetails(playlist.id);
              return { ...playlist, followers: details.followers };
            } catch (error) {
              console.error(`Error fetching details for playlist ${playlist.id}:`, error);
              return playlist;
            }
          })
        );
        data.playlists.items = playlistsWithDetails;
      }

      return data;
    } catch (error) {
      console.error('Error in searchPlaylists:', error);
      throw error;
    }
  }

  async getPlaylistDetails(playlistId) {
    try {
      const headers = await this.getHeaders();
      const response = await fetch(
        `${this.baseUrl}/playlists/${playlistId}`,
        { 
          method: 'GET',
          headers 
        }
      );

      if (!response.ok) {
        throw new Error(`Failed to get playlist details: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error in getPlaylistDetails:', error);
      throw error;
    }
  }
}

export default new SpotifyService();